import { Container } from '@/components/layout/Container'
import { FadeUp } from '@/components/motion/FadeUp'
import { HomeCTA } from '@/components/home/HomeCTA'
import { HomeFeedback } from '@/components/home/HomeFeedback'
import { SECTION_PY } from '@/lib/layoutSpacing'

export function HomeCTAFeedbackRow() {
  return (
    <section className={SECTION_PY}>
      <Container>
        <FadeUp>
          <div className="grid gap-4 lg:grid-cols-2 lg:items-stretch">
            <HomeCTA embedded />
            <HomeFeedback embedded />
          </div>
        </FadeUp>
      </Container>
    </section>
  )
}
